import React from "react";
import styled from "styled-components";

export default styled.video`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    max-height: 70vh;
`; 